import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, TableCell,
  Table, TableHead, TableRow, TableBody, TableContainer, MenuItem
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import _ from 'lodash';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import { LoadingComponent } from 'src/utils/newLoader';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));

const screenCode = 'COPREPORT2';

export default function COPReport2(props) {
  const [title, setTitle] = useState("COP Report 2");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [copInput, setCopInput] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    costPerUnit: ''
  });
  const [copData, setCopData] = useState([]);
  const [madeTea, setMadeTea] = useState(0);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    routeName: "",
    groupName: "",
    factoryName: "",
    startDate: '',
    endDate: '',
    registrationNumber: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const componentRef = useRef();
  const [csvHeaders, SetCsvHeaders] = useState([]);
  useEffect(() => {
    trackPromise(
      getPermission());
    trackPromise(
      getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
    setMadeTea(0);
  }, [copInput.groupID]);

  useEffect(() => {
    setMadeTea(0);
  }, [copInput.factoryID]);
  useEffect(() => {
    setCopData([]);
    setMadeTea(0);
  }, [startDate, endDate]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCOPREPORT2');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setCopInput({
      ...copInput,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(copInput.groupID);
    setFactoryList(factories);
  }

  async function GetDetails() {
    let copDetailsModel = {
      groupID: parseInt(copInput.groupID),
      factoryID: parseInt(copInput.factoryID),
      startDate: new Date(startDate),
      endDate: new Date(endDate)
    }

    getSelectedDropdownValuesForReport(copDetailsModel);

    const response = await services.GetCopReportDetails(copDetailsModel);
    if (response.statusCode == "Success" && response.data != null) {
      let costPerUnit = 0;
      let primaryCost = 0;
      let totalCost = 0;
      let totalCpu = 0;
      let totalRawMaterials = 0;
      let totalFactoryOverhead = 0;
      let totalDirectLabourCpu = 0;
      response.data.forEach(x => {
        costPerUnit = madeTea != 0 ? parseFloat(x.amount) / parseFloat(madeTea) : "";
        x.costPerUnit = costPerUnit
        if (x.categoryName === "Raw Materials") {
          totalRawMaterials += x.amount;
        }

        if (x.categoryName === "Raw Materials" || x.categoryName === "Direct Labour") {
          primaryCost += x.amount
          if (x.categoryName === "Direct Labour") {
            totalDirectLabourCpu += x.costPerUnit;
          }
        }
        if (x.categoryName === "Factory Overheads") {
          totalFactoryOverhead += x.amount;
        }
        totalCost += x.amount
        totalCpu += x.costPerUnit
      });
      response.data.primaryCost = primaryCost;
      response.data.totalCost = totalCost;
      response.data.totalCpu = response.data.totalCpu == 0 ? "" : totalCpu;
      response.data.totalRawMaterials = totalRawMaterials;
      response.data.rawMaterialsCpu = madeTea != 0 ? parseFloat(totalRawMaterials) / parseFloat(madeTea) : "";
      response.data.totalFactoryOverhead = totalFactoryOverhead;
      response.data.totalFactoryOverheadCpu = madeTea != 0 ? parseFloat(totalFactoryOverhead) / parseFloat(madeTea) : "";
      response.data.productionCost = primaryCost + totalFactoryOverhead;
      response.data.productionCostCpu = madeTea != 0 ? parseFloat(response.data.productionCost) / parseFloat(madeTea) : "";
      response.data.primaryCpu = totalDirectLabourCpu + response.data.rawMaterialsCpu;
      setCopData(response.data);
      if (response.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(response.message);
    }
  }

  async function createFile() {
    var file = await createDataForExcel(copData);
    var settings = {
      sheetName: 'COP Report',
      fileName: 'COP Report - ' + selectedSearchValues.factoryName + ' ' + selectedSearchValues.startDate + ' ' + selectedSearchValues.endDate,
      writeOptions: {}
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    tempcsvHeaders.push({ label: 'Description', value: 'description' })
    tempcsvHeaders.push({ label: 'Amount    ', value: 'amount' })
    tempcsvHeaders.push({ label: '         ', value: 'total' })
    tempcsvHeaders.push({ label: 'AVG    ', value: 'costPerUnit' })
    let dataA = [
      {
        sheet: 'COP Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  async function createDataForExcel(array) {
    let res = [];
    if (!array || array.length === 0) return res;

    const formatNum = (num) => num == null || num === "" ? "" : parseFloat(num).toFixed(2);
    res.push({ description: 'Raw Materials', amount: '', total: '', costPerUnit: '' });

    array
      .filter(x => x.categoryName === "Raw Materials" && x.amount != 0)
      .forEach(data => {
        res.push({
          description: "     " + data.accountDescriptionTypeName,
          amount: formatNum(data.amount),
          total: '',
          costPerUnit: formatNum(data.costPerUnit)
        });
      });

    res.push({
      description: 'Cost of RM',
      amount: formatNum(array.totalRawMaterials || 0),
      total: '',
      costPerUnit: array.rawMaterialsCpu == 0 ? "" : formatNum(array.rawMaterialsCpu)
    });

    array
      .filter(x => x.categoryName === "Direct Labour" && x.amount != 0)
      .forEach(data => {
        res.push({
          description: "     " + data.accountDescriptionTypeName,
          amount: formatNum(data.amount),
          total: '',
          costPerUnit: formatNum(data.costPerUnit)
        });
      });

    res.push({
      description: 'Primary Cost',
      amount: '',
      total: array.primaryCost == 0 ? "" : formatNum(array.primaryCost),
      costPerUnit: array.primaryCpu == 0 ? "" : formatNum(array.primaryCpu)
    });

    res.push({ description: 'Additions(Overhead cost)', amount: '', total: '', costPerUnit: '' });

    array
      .filter(x => x.categoryName === "Factory Overheads" && x.amount != 0)
      .forEach(data => {
        res.push({
          description: "     " + data.accountDescriptionTypeName,
          amount: formatNum(data.amount),
          total: '',
          costPerUnit: formatNum(data.costPerUnit)
        });
      });

    res.push({
      description: 'Total Factory Additions',
      amount: '',
      total: array.totalFactoryOverhead == 0 ? "" : formatNum(array.totalFactoryOverhead),
      costPerUnit: array.totalFactoryOverheadCpu == 0 ? "" : formatNum(array.totalFactoryOverheadCpu)
    });

    array
      .filter(x => x.categoryName === "Factory OverHeads" && x.amount != 0)
      .forEach(data => {
        res.push({
          description: "     " + data.accountDescriptionTypeName,
          amount: formatNum(data.amount),
          total: '',
          costPerUnit: formatNum(data.costPerUnit)
        });
      });

    res.push({
      description: 'Total Cost Of Production',
      amount: '',
      total: formatNum(array.productionCost || 0),
      costPerUnit: array.productionCostCpu == 0 ? "" : formatNum(array.productionCostCpu)
    });

    res.push({});
    res.push({
      description: 'Group :' + selectedSearchValues.groupName,
      amount: 'Factory :' + selectedSearchValues.factoryName,
      total: '',
      costPerUnit: ''
    });
    res.push({
      description: 'From Date :' + selectedSearchValues.startDate,
      amount: 'To date :' + selectedSearchValues.endDate,
      total: '',
      costPerUnit: ''
    });
    return res;
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setCopInput({
      ...copInput,
      [e.target.name]: value
    });
    setCopData([]);
  }

  function handleMadeTeaChange(e) {
    const target = e.target;
    const value = target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setMadeTea(value);
    }
    setCopData([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    var startDate = moment(searchForm.startDate.toString()).format().split('T')[0]
    var endDate = moment(searchForm.endDate.toString()).format().split('T')[0]
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      startDate: startDate,
      endDate: endDate
    })
  }

  function handleMadeTeaBlur(e) {
    const target = e.target;
    const value = target.value;
    if (value !== "" && !isNaN(value)) {
      setMadeTea(parseFloat(value).toFixed(2));
    }
  }
  const getPageMargins = () => {
    return `@media print {
    @page {
      size: A5 portrait ;
      margin-top: 0 !important;
      margin-left:150px  !important;
      margin-right:150px  !important;
    }

    html, body, #root, div , #app{
      margin: 0 !important;
      padding: 0 !important;
      background: white !important;  
    }
    h3{
      margin-top: 25px !important;
    }    
  }`;
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: copInput.groupID,
              factoryID: copInput.factoryID,
              startDate: startDate,
              endDate: endDate,
              madeTea: madeTea
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                startDate: Yup.date().required('From Date is Required'),
                endDate: Yup.date().required('To Date is Required'),
              })
            }
            onSubmit={() => trackPromise(GetDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={copInput.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={copInput.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>From Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name='startDate'
                                id='startDate'
                                value={startDate}
                                maxDate={new Date()}
                                onChange={(e) => {
                                  setStartDate(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>To Date *</InputLabel>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                name='startDate'
                                id='startDate'
                                value={endDate}
                                onChange={(e) => {
                                  setEndDate(e)
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date',
                                }}
                                autoOk
                                maxDate={new Date()}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="madeTea">
                              Made Tea
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="madeTea"
                              onChange={(e) => handleMadeTeaChange(e)}
                              onBlur={(e) => handleMadeTeaBlur(e)}
                              value={madeTea}
                              variant="outlined"
                              id="madeTea"
                              size='small'
                            >
                            </TextField>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      {copData.length > 0 ?
                        <Grid style={{ justifyContent: 'center', justifyItems: 'center' }}>
                          <Box
                            style={{
                    
                              margin: '0 auto',
                              marginTop: '20px',
                              marginBottom: '20px',
                            }}
                          > 
                          
                            <h2 style={{ textAlign: 'center' }}>{selectedSearchValues.factoryName}</h2>
                            <h3 style={{textAlign: 'center',whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',}}>
                              Cost Of Production - (
                              {moment(selectedSearchValues.startDate).format('DD/MM/YYYY')} - {moment(selectedSearchValues.endDate).format('DD/MM/YYYY')}
                              )
                            </h3>
                            
                          </Box>

                          <br></br>
                          <Box
                            style={{
                              width: '60%',
                              margin: '0 auto',
                              
                            }} >
                            <TableContainer>
                              <Table aria-label="caption table">
                                <TableHead>
                                  <TableRow>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', border: '1px solid black' }}>Amount</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'center', border: '1px solid black' }}>Avg</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', border: '1px solid black' }}>Raw Materials</TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                  </TableRow>
                                  {copData.filter(x => x.categoryName === "Raw Materials" && x.amount != 0).map((data, index) => (
                                    <TableRow key={index}>
                                      <TableCell style={{ paddingLeft: '5%', border: '1px solid black' }}>{data.accountDescriptionTypeName}</TableCell>
                                      <TableCell style={{ textAlign: 'right', border: '1px solid black' }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                      <TableCell style={{ border: '1px solid black' }}></TableCell>
                                      <TableCell style={{ textAlign: 'right', border: '1px solid black' }}>{data.costPerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                  ))}
                                  <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', border: '1px solid black' }}>Cost of RM</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'right', border: '1px solid black' }}>{copData.length == 0 ? "" : copData.totalRawMaterials.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'right', border: '1px solid black' }}>{copData.length == 0 ? "" : copData.rawMaterialsCpu == 0 ? "" : copData.rawMaterialsCpu.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                  </TableRow>
                                  {copData.filter(x => x.categoryName === "Direct Labour" && x.amount != 0).map((data, index) => (
                                    <TableRow key={index}>
                                      <TableCell style={{ paddingLeft: '5%', border: '1px solid black' }}>{data.accountDescriptionTypeName}</TableCell>
                                      <TableCell style={{ textAlign: 'right', border: '1px solid black' }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                      <TableCell style={{ border: '1px solid black' }}></TableCell>
                                      <TableCell style={{ textAlign: 'right', border: '1px solid black' }}>{data.costPerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                  ))}
                                  <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', border: '1px solid black' }}>Primary Cost</TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'right', border: '1px solid black' }}>{copData.length == 0 ? "" : copData.primaryCost == 0 ? "" : copData.primaryCost.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'right', border: '1px solid black' }}>{copData.length == 0 ? "" : copData.primaryCpu == 0 ? "" : copData.primaryCpu.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', border: '1px solid black' }}>Additions(Overhead cost)</TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                  </TableRow>
                                  {copData.filter(x => x.categoryName === "Factory Overheads" && x.amount != 0).map((data, index) => (
                                    <TableRow key={index}>
                                      <TableCell style={{ paddingLeft: '5%', border: '1px solid black' }}>{data.accountDescriptionTypeName}</TableCell>
                                      <TableCell style={{ textAlign: 'right', border: '1px solid black' }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                      <TableCell style={{ border: '1px solid black' }}></TableCell>
                                      <TableCell style={{ textAlign: 'right', border: '1px solid black' }}>{data.costPerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                  ))}
                                  <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', border: '1px solid black' }}>Total Factory Additions</TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'right', border: '1px solid black' }}>{copData.totalFactoryOverhead.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'right', border: '1px solid black' }}>{copData.totalFactoryOverheadCpu.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                  </TableRow>
                                  {copData.filter(x => x.categoryName === "Factory OverHeads" && x.amount != 0).map((data, index) => (
                                    <TableRow key={index}>
                                      <TableCell style={{ paddingLeft: '5%', border: '1px solid black' }}>{data.accountDescriptionTypeName}</TableCell>
                                      <TableCell style={{ textAlign: 'right', border: '1px solid black' }}>{data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                      <TableCell style={{ border: '1px solid black' }}></TableCell>
                                      <TableCell style={{ textAlign: 'right', border: '1px solid black' }}>{data.costPerUnit.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                    </TableRow>
                                  ))}
                                  <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', border: '1px solid black' }}>Total Cost Of Production</TableCell>
                                    <TableCell style={{ border: '1px solid black' }}></TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'right', border: '1px solid black' }}>{copData.length != 0 ? copData.productionCost.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ""}</TableCell>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'right', border: '1px solid black' }}>{copData.length == 0 ? "" : copData.productionCostCpu == 0 ? "" : copData.productionCostCpu.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                          {copData.length > 0 ?
                            <Box
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                margin: '20px 0'
                              }}>
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={createFile}
                              >
                                EXCEL
                              </Button>

                              <ReactToPrint
                                documentTitle={`COP Report 2_${selectedSearchValues.factoryName}_From:${selectedSearchValues.startDate}_To:${selectedSearchValues.endDate}`}
                                trigger={() => <Button
                                  color="primary"
                                  id="btnRecord"
                                  type="submit"
                                  variant="contained"
                                  style={{ marginRight: '1rem' }}
                                  className={classes.colorCancel}
                                >
                                  PDF
                                </Button>}
                                pageStyle={getPageMargins()}
                                content={() => componentRef.current}
                              />
                              <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                  copData={copData} selectedSearchValues={selectedSearchValues} copInput={copInput}
                                />
                              </div>
                            </Box> : null}
                        </Grid>
                        : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
